import React, { useEffect, useState } from 'react';
import Breadcrum from '../../components/common/Breadcrum';
import ServerTable from '../../components/table/ServerTable';
import Select from '../../components/form/Select';
import Models from '../../components/common/Models';
import moment from 'moment';
import axiosInstance from '../../services/axios';
import { toast } from 'react-toastify';
import DatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

export default function EmployeeLeads() {
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [searchTerm, setSearchTerm] = useState('');
  const [sourceFilter, setSourceFilter] = useState('ALL');
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  
  const [tableRow, setTableRow] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  const [selectedLead, setSelectedLead] = useState(null);
  const [viewLeadData, setViewLeadData] = useState(null);
  const [leadsList, setLeadsList] = useState([]);
  const [sourcesList, setSourcesList] = useState([]);
  
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    source: ''
  });
  
  const [loading, setLoading] = useState(false);
  const [totalLeads, setTotalLeads] = useState(0);

  const breadcrumbItems = [

    { label: 'My Leads', path: '/employee/leads' }
  ];

  const tableColumns = [
    { id: 'serialNo', label: 'S.No', type: 'text' },
    { id: 'name', label: 'Name', type: 'text' },
    { id: 'email', label: 'Email', type: 'text' },
    { id: 'phone', label: 'Phone', type: 'text' },
    { id: 'source', label: 'Source', type: 'text' },
    { id: 'status', label: 'Status', type: 'boolean' },
    { id: 'createdAt', label: 'Created', type: 'date' },
    
  ];

  const handleSearch = (value) => {
    setSearchTerm(value);
    setCurrentPage(1);
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleRowsPerPageChange = (value) => {
    setRowsPerPage(value);
    setCurrentPage(1);
  };
  const getLeadSources = async () => {
    try {
      const response = await axiosInstance.get('/leads/sources');
      setSourcesList(response.data.data || []);
    } catch (error) {
      console.error('Failed to fetch lead sources');
    }
  };

  const getMyLeads = async () => {
    setLoading(true);
    try {
      const params = {
        page: currentPage,
        limit: rowsPerPage,
        search: searchTerm || undefined,
        source: sourceFilter === 'ALL' ? undefined : sourceFilter,
        startDate: startDate ? moment(startDate).format('YYYY-MM-DD') : undefined,
        endDate: endDate ? moment(endDate).format('YYYY-MM-DD') : undefined
      };

      const response = await axiosInstance.get('/leads', { params });
      // Filter only leads assigned to current employee
      let currentUser = JSON.parse(localStorage.getItem('user'))?.id || '';
      console.log(currentUser);
      const myLeads = response.data.data.leads?.filter(lead => lead.assignedTo === currentUser) || [];
      setLeadsList(myLeads);
      setTotalLeads(myLeads.length);
    } catch (error) {
      toast.error('Failed to fetch my leads');
      setLeadsList([]);
    } finally {
      setLoading(false);
    }
  };

  const handleTableAction = async (action, row) => {
    if (action === 'View') {
      try {
        const response = await axiosInstance.get(`/leads/${row.uuid}`);
        setViewLeadData(response.data.data);
        setIsViewModalOpen(true);
      } catch (error) {
        toast.error('Failed to fetch lead details');
      }
    } else if (action === 'Edit') {
      setSelectedLead(row);
      setFormData({
        name: row.originalName || '',
        email: row.originalEmail || '',
        phone: row.originalPhone || '',
        source: row.originalSource || ''
      });
      setIsModalOpen(true);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      if (selectedLead) {
        // Update lead
        await axiosInstance.put(`/leads/${selectedLead.uuid}`, formData);
        toast.success('Lead updated successfully');
      } else {
        // Create new lead
        await axiosInstance.post('/leads', formData);
        toast.success('Lead created successfully');
      }
      
      // Refresh leads list after successful operation
      await getMyLeads();
      resetForm();
    } catch (error) {
      toast.error(selectedLead ? 'Failed to update lead' : 'Failed to create lead');
    } finally {
      setLoading(false);
    }
  };

  const resetForm = () => {
    setFormData({
      name: '',
      email: '',
      phone: '',
      source: ''
    });
    setSelectedLead(null);
    setIsModalOpen(false);
  };
  
  useEffect(() => {
    getLeadSources();
  }, []);

  useEffect(() => {
    getMyLeads();
  }, [currentPage, rowsPerPage, searchTerm, sourceFilter, startDate, endDate]);

  useEffect(() => {
    if (leadsList && Array.isArray(leadsList)) {
      const updatedRows = leadsList?.map((lead, index) => ({
        uuid: lead.id,
        serialNo: (currentPage - 1) * rowsPerPage + index + 1,
        name: lead.name || 'No Name',
        email: lead.email || 'No Email',
        phone: lead.phone || 'No Phone',
        source: lead.source || 'No Source',
        status: lead.status || false,
        createdAt: moment(lead.createdAt).format('YYYY-MM-DD'),
        // Store original values for editing - make sure these exist
        originalName: lead.name || '',
        originalEmail: lead.email || '',
        originalPhone: lead.phone || '',
        originalSource: lead.source || ''
      }));
      setTableRow(updatedRows);
    } else {
      setTableRow([]);
    }
  }, [leadsList, currentPage, rowsPerPage]);

  const sourceOptions = [
    { value: "ALL", label: "All Sources" },
    ...sourcesList.map(source => ({ value: source, label: source }))
  ];

  return (
    <>
      <div className='bg-gray-200 dark:bg-gray-800 py-2 px-4 rounded-lg flex justify-between items-center'>
        <div>
          <h1 className='text-2xl font-semibold text-theme-dark dark:text-theme-light'>My Leads</h1>
          <Breadcrum items={breadcrumbItems} />
        </div>
        <div className='flex justify-end items-center gap-3 flex-wrap md:flex-nowrap'>
          {/* <Select
            options={sourceOptions}
            value={sourceFilter}
            onChange={(selected) => setSourceFilter(selected)}
            placeholder="Filter by Source"
          /> */}
          <DatePicker
            className='p-2 rounded-lg border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100'
            selectsRange={true}
            startDate={startDate}
            endDate={endDate}
            onChange={(update) => setDateRange(update)}
            isClearable={true}
            placeholderText="Select date range"
          />
          {/* <button
            onClick={() => setIsModalOpen(true)}
            className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-lg whitespace-nowrap"
          >
            Add New Lead
          </button> */}
        </div>
      </div>

      <div className='mt-4'>
        <ServerTable
          tableColumns={tableColumns}
          title="My Leads"
          data={tableRow}
          total={totalLeads}
          loading={loading}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[10, 25, 50]}
          searchTerm={searchTerm}
          onSearch={handleSearch}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
          handleTableAction={handleTableAction}
        />
      </div>

      {/* Lead Modal */}
      <Models isOpen={isModalOpen} isClose={resetForm}>
        <div className="p-6 max-w-2xl w-full">
          <h2 className="text-xl font-bold mb-4">
            {selectedLead ? 'Edit Lead' : 'Add New Lead'}
          </h2>
          <form onSubmit={handleSubmit}>
            <div className="grid grid-cols-1 gap-4">
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Name *</label>
                <input
                  type="text"
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter lead name"
                  required
                />
              </div>
              
              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Email *</label>
                <input
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter lead email"
                  required
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700">Phone</label>
                <input
                  type="text"
                  value={formData.phone}
                  onChange={(e) => setFormData({...formData, phone: e.target.value})}
                  className="w-full p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
                  placeholder="Enter lead phone number"
                />
              </div>

              <div>
                <label className="block text-sm font-medium mb-1 text-gray-700 dark:text-gray-300">Source</label>
                <input
                  type="text"
                  value={formData.source}
                  onChange={(e) => setFormData({...formData, source: e.target.value})}
                  className="w-full p-3 border border-gray-300 dark:border-gray-600 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-gray-100"
                  placeholder="Enter lead source (e.g., Website, Referral, Social Media)"
                  list="sources-list"
                />
                <datalist id="sources-list">
                  {sourcesList.map((source, index) => (
                    <option key={index} value={source} />
                  ))}
                </datalist>
              </div>
            </div>

            <div className="flex justify-end gap-2 mt-6">
              <button
                type="button"
                onClick={resetForm}
                className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400 transition-colors"
                disabled={loading}
              >
                Cancel
              </button>
              <button
                type="submit"
                className="px-6 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors disabled:opacity-50"
                disabled={loading}
              >
                {loading ? 'Saving...' : (selectedLead ? 'Update Lead' : 'Create Lead')}
              </button>
            </div>
          </form>
        </div>
      </Models>

      {/* View Lead Modal */}
      <Models isOpen={isViewModalOpen} isClose={() => setIsViewModalOpen(false)}>
        {viewLeadData && (
          <div className="p-6 max-w-3xl w-full">
            <div className="flex justify-between items-start mb-6">
              <h2 className="text-2xl font-bold text-gray-800">Lead Details</h2>
              <button
                onClick={() => setIsViewModalOpen(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
              </button>
            </div>

            <div className="space-y-6">
              {/* Lead Information */}
              <div className="bg-gray-50 p-4 rounded-lg">
                <h3 className="text-lg font-semibold mb-3 text-gray-700">Lead Information</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Name</label>
                    <p className="mt-1 text-gray-900 font-medium">{viewLeadData.name}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Email</label>
                    <p className="mt-1 text-gray-900">{viewLeadData.email}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Phone</label>
                    <p className="mt-1 text-gray-900">{viewLeadData.phone || 'No phone number'}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Source</label>
                    <p className="mt-1 text-gray-900">{viewLeadData.source || 'No source'}</p>
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-600">Created At</label>
                    <p className="mt-1 text-gray-900">{moment(viewLeadData.createdAt).format('YYYY-MM-DD HH:mm:ss')}</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="flex justify-end mt-6">
              <button
                onClick={() => setIsViewModalOpen(false)}
                className="px-6 py-2 bg-gray-300 text-gray-700 rounded-lg hover:bg-gray-400"
              >
                Close
              </button>
            </div>
          </div>
        )}
      </Models>
    </>
  );
}